import React  from 'react';
import PropTypes from 'prop-types';
import {Button, Dropdown } from 'react-bootstrap';
import cn from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import appConfig from '../../appConfig';
import { changeLocale } from '../../actions/session';
import {allowDropHandler, openExternalLink} from '../../utils/uiUtils';
import { stringifiedToDraggable } from '../../utils/draggables';
import { moveUmoHandler } from '../../utils/umoUtils';
import { SearchParams } from '../../utils/searchUtils';
import SearchSimple from '../SearchBar/SearchSimple';

function Header({
  username,
  locale,
  logout,
  onWorkspaceToggle,
  isWorkspacePreviewShown,
  isAdvancedSearchShown,
  selectedWorkspaceName,
  selectedWorkspaceID,
  dispatch,
  searchParams,
  onAdvancedSearchToggle,
  isWorkbench,
  onHomeClick,
}) {
  const userActions = [];
  const dropHandler = (e) => {
    e.preventDefault();
    const draggable = stringifiedToDraggable(e.dataTransfer.getData('text'));
    if (!(draggable instanceof Error)) {
      const origin = {
        id: draggable.originData.workspaceID,
        isWorkspace: draggable.isWorkspaceItem(),
      };
      const target = {
        id: selectedWorkspaceID,
        isWorkspace: true,
      };
      moveUmoHandler(origin, target, draggable.getSelectionList(), dispatch,
        draggable.getIsSelectAll() ? draggable.getSearchParams() : null);
    }
  };

  const logo = appConfig.logoLink ?
    <button className="header__logo" onClick={() => openExternalLink(appConfig.logoLink)}>&nbsp;</button>
    : <button className="header__logo" onClick={onHomeClick}>&nbsp;</button>;

  userActions.push(
    <Dropdown.Item className="header__dropdown-link" key={1} onClick={logout}>
      <FormattedMessage id="general.logout" description="Logout link"/>
    </Dropdown.Item>);
  if (appConfig.showLanguageSelection) {
    userActions.push(<Dropdown.Divider key={5}/>);
    userActions.push(<Dropdown.Header key={6}><FormattedMessage id="general.language" /></Dropdown.Header>);
    userActions.push(
      <Dropdown.Item
        disabled={locale === 'en'}
        key={2}
        className="header__dropdown-link"
        eventKey={'lang_en'}
        onClick={() => dispatch(changeLocale('en'))}
      >
        <FormattedMessage id="general.language.english" />
      </Dropdown.Item>);
    userActions.push(
      <Dropdown.Item
        disabled={locale === 'fr'}
        key={3}
        className="header__dropdown-link"
        eventKey={'lang_fr'}
        onClick={() => dispatch(changeLocale('fr'))}
      >
        <FormattedMessage id="general.language.french" />
      </Dropdown.Item>);
  }

  return (
    <div className="header">
      {logo}
      <SearchSimple searchParams={searchParams} dispatch={dispatch} />
      <button
        className={cn('header__advSearch-button', { 'header__advSearch-button--open': isAdvancedSearchShown })}
        onClick={() => onAdvancedSearchToggle()}
      >
        <FormattedMessage id="searchBar.advancedButton" description="open Advanced search button" />
        <span
          className={
            isAdvancedSearchShown ? 'header__workspace-collapse-icon' :
              'header__workspace-expand-icon'
          }
        />
      </button>
      {appConfig.addExternalButton && appConfig.addExternalButton.url ?
      <Button className='header__ext-link' variant="secondary" size="sm" onClick={() => openExternalLink(appConfig.addExternalButton.url)}>
        {appConfig.addExternalButton.label || 'External'}
      </Button>
        : null }
        <div className='header__spacer' />
      {appConfig.removeWorkspaces ? null : <button
        className={cn('header__workspace-button','btn', { 'header__workspace-button--wb': isWorkbench })}
        onClick={() => onWorkspaceToggle()}
        onDrop={dropHandler}
        onDragOver={selectedWorkspaceID ? allowDropHandler : null}
      >
        <span className="header__workspace-icon" />
        {selectedWorkspaceName}
        <span
          className={
            isWorkspacePreviewShown ? 'header__workspace-collapse-icon' :
            'header__workspace-expand-icon'
          }
        />
      </button>}
      { appConfig.removeLogoutBtn ? null :
        <Dropdown>
          <Dropdown.Toggle
            as={Button}
            variant="default"
            className={cn('header__dropdown-button', {'header__dropdown-button--wb': isWorkbench})}
            id="user-dropdown"
            kay={0}
          >
            <i className="header__icon" />
            {username}
            <i className="header__icon-down" />
          </Dropdown.Toggle>
          <Dropdown.Menu className="header__usermenu">
            {userActions}
          </Dropdown.Menu>
        </Dropdown>
      }
    </div>
  );
}

Header.propTypes = {
  logout: PropTypes.func,
  onWorkspaceToggle: PropTypes.func,
  onAdvancedSearchToggle: PropTypes.func,
  username: PropTypes.string,
  locale: PropTypes.string,
  isWorkspacePreviewShown: PropTypes.bool,
  isAdvancedSearchShown: PropTypes.bool,
  selectedWorkspaceName: PropTypes.string,
  selectedWorkspaceID: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  searchParams: PropTypes.instanceOf(SearchParams),
  isWorkbench: PropTypes.bool,
  onHomeClick: PropTypes.func,
};

export default injectIntl(Header);



// WEBPACK FOOTER //
// ./src/js/components/Header/index.jsx